import {
  ROUTE_BILLING,
  ROUTE_PAYMENTS,
  ROUTE_PLAN_CANCEL,
  ROUTE_PLAN_CONFIRMATION,
  ROUTE_PLAN_UPGRADE,
  ROUTE_PLANS,
  ROUTE_PLANS_AND_BILLING,
  ROUTE_PROFILE_PLANS,
  ROUTE_UPGRADE_PLAN,
} from './constants';

// The Plus Plans and Holiday Sale purchase flows lived in their own modules,
// which are deleted with this redirect.
export const ROUTE_LEGACY_PLUS_PLANS = '/plus';
export const ROUTE_LEGACY_HOLIDAY_SALE = '/holiday-sale';

// The Chargify-era plan, billing, payment, upgrade and cancel pages, and the
// Plus Plans and Holiday Sale purchase flows, read or wrote Chargify, whose
// account is cancelled. `/plans-and-billing` (the Chargebee self-serve portal)
// replaces all of them, so old links and bookmarks land there
// (hubspot-off-block-3 task 96).
//
// The Renderer mounts a redirect entry as a `<Redirect>` without `exact`, so
// each entry also covers its sub-paths (for example `/plus/digital/review`).
// A path segment must match in full: `/plans` does not match
// `/plans-and-billing`, which renders its page as before.
export const LEGACY_BILLING_PATHS = [
  ROUTE_PLANS,
  ROUTE_UPGRADE_PLAN,
  ROUTE_PLAN_CONFIRMATION,
  ROUTE_PAYMENTS,
  ROUTE_BILLING,
  ROUTE_PROFILE_PLANS,
  ROUTE_PLAN_UPGRADE,
  ROUTE_PLAN_CANCEL,
  ROUTE_LEGACY_PLUS_PLANS,
  ROUTE_LEGACY_HOLIDAY_SALE,
];

export const legacyBillingRedirectRoutes = LEGACY_BILLING_PATHS.map((path) => ({
  path,
  redirect: ROUTE_PLANS_AND_BILLING,
}));

export default legacyBillingRedirectRoutes;
